import { useEffect } from "react";
import Logo from "@/components/Logo";
import { useTheme } from "@/components/ThemeProvider";
import { LOGIN_DOCUMENT_TITLE, resetLoginDocumentBranding } from "@/lib/tenant-brand";

/** Lock auth pages to the light marketing shell (no tenant whitelabel bleed). */
export function useAuthPageSetup(documentTitle = LOGIN_DOCUMENT_TITLE) {
  const { setTheme } = useTheme();
  useEffect(() => {
    resetLoginDocumentBranding(documentTitle);
    setTheme("light", true);
  }, [documentTitle, setTheme]);
}

function SignalStyleAside() {
  return (
    <div className="auth-login-aside w-full flex items-center justify-center">
      <img
        src="/auth/aivoryems-login-hero.jpg"
        alt="AivoryEMS — Events Made Smarter"
        className="auth-login-hero-img w-full h-auto block"
        width={1254}
        height={1254}
        decoding="async"
      />
    </div>
  );
}

/**
 * @param {'split'|'centered'} variant — Signal split card vs simple centered card
 */
export default function AuthPageShell({ variant = "split", children, aside, documentTitle }) {
  useAuthPageSetup(documentTitle);

  if (variant === "centered") {
    return (
      <div className="auth-shell min-h-screen flex flex-col items-center justify-center p-6 bg-[#f5f5f5]">
        <Logo size={44} />
        <div className="w-full max-w-md mt-10 auth-shell-card">{children}</div>
      </div>
    );
  }

  return (
    <div className="auth-shell min-h-screen bg-[#f5f5f5] flex items-stretch md:items-center justify-center p-0 sm:p-4 md:p-6 lg:p-10">
      <div className="auth-signal-card w-full max-w-[1080px] mx-auto grid md:grid-cols-2 bg-white rounded-none sm:rounded-[24px] md:rounded-[28px] overflow-hidden">
        {/* Square artwork at intrinsic ratio — never object-cover crop */}
        <div className="auth-login-aside-wrap order-1 bg-[#F3F5F2] flex items-center justify-center self-stretch">
          {aside || <SignalStyleAside />}
        </div>

        <div className="order-2 flex items-start md:items-center justify-center px-5 py-8 sm:px-8 md:px-12 lg:px-14">
          <div className="w-full max-w-[360px] py-1 sm:py-2">
            <div className="mb-7 sm:mb-8 flex justify-center items-center gap-2.5">
              <Logo size={34} />
              <span className="text-[1.05rem] font-semibold tracking-tight text-[#111827]">AivoryEMS</span>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
